import { Input } from 'ui';
import { useIntl } from 'react-intl';
import { useState } from 'react';
import { AdresSearch, AMKResponse } from '../../../../../ui/AdressSearch';
import { FormInstance } from 'antd';

interface FarmInfoProps {
  form: FormInstance;
}

export const FarmInfo = ({ form }: FarmInfoProps) => {
  const intl = useIntl();
  const [adressSearchFieldName, setAdressSearchFieldName] =
    useState<string>('');

  return (
    <>
      <AdresSearch
        isOpen={!!adressSearchFieldName}
        setIsOpen={setAdressSearchFieldName}
        onItemSelect={(event: AMKResponse) => {
          if (event.data?.code) {
            if (event.data?.irAdrese ?? false) {
              form.setFieldValue(
                adressSearchFieldName,
                `${event.data?.address}, ${event.data?.zipCode}`
              );
              form.validateFields([adressSearchFieldName]);
              setAdressSearchFieldName('');
            } else {
              alert(intl.formatMessage({ id: 'message.add_full_address' }));
            }
          }
        }}
      />
      <div className={'inputs'}>
        <div className={'collum'}>
          <div className="full-collum">
            {intl.formatMessage({
              id: 'profile.company_name',
            })}
            <Input
              size={'large'}
              name={'company_name'}
              validations={'required'}
            />
          </div>
        </div>

        <div className="full-collum">
          {intl.formatMessage({ id: 'profile.brand' })}
          <Input size={'large'} name={'brand'} />
        </div>

        <div className="full-collum">
          {intl.formatMessage({ id: 'profile.webpage' })}
          <Input size={'large'} name={'website'} validations={'required'} />
        </div>

        <div className="full-collum">
          {intl.formatMessage({ id: 'farms.reg_nr' })}
          <Input size={'large'} name={'reg_nr'} validations={'regNr'} />
        </div>

        <div className="full-collum">
          {intl.formatMessage({ id: 'profile.tax_payer_number' })}
          <Input size={'large'} name={'pvn_nr'} validations={'required'} />
        </div>

        <div className="full-collum">
          {intl.formatMessage({ id: 'farms.pvd_nr' })}
          <Input size={'large'} name={'pvd_nr'} validations={'required'} />
        </div>

        <h3>{intl.formatMessage({ id: 'profile.company_adress' })}</h3>

        <div className="full-collum">
          {intl.formatMessage({ id: 'profile.legal_adress' })}
          <span onClick={() => setAdressSearchFieldName('legal_adress')}>
            <Input
              size={'large'}
              name={'legal_adress'}
              validations={'required'}
              readOnly
            />
          </span>
        </div>
        <div className="full-collum">
          {intl.formatMessage({ id: 'profile.physical_address' })}
          <span onClick={() => setAdressSearchFieldName('physical_address')}>
            <Input
              size={'large'}
              name={'physical_address'}
              validations={'required'}
              readOnly
            />
          </span>
        </div>
      </div>
    </>
  );
};
